/* eslint-disable no-console */
const consoleError = window.console && console.error ? (
  (...args) => {
    console.error(...args);
  }
) : (
  () => {}
);

export default consoleError;



// WEBPACK FOOTER //
// ./src/lib/logger/error.js